/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import { SvgIcons } from '../../svgIcons'
import FabricCanvasTool from '../fabrictool'

import { fabric } from '@/@corefabriccanvas/fabric/dist/fabric'
class Crop extends FabricCanvasTool {
  configureCanvas(props) {
    const canvas = this._canvas
    canvas.isDrawingMode = canvas.selection = false
    // canvas.freeDrawingCursor=`url(${getDrawCursor()}) ${0} ${24}, crosshair`
    canvas.freeDrawingCursor = `url(${SvgIcons.getAsImageSrc(
      SvgIcons.Crop
    )}) ${2} ${24}, crosshair`
    // eslint-disable-next-line no-return-assign
    canvas.forEachObject((o) => (o.selectable = o.evented = false))
    this._width = props.lineWidth
    this._color = props.lineColor
    this._fill = props.fillColor
  }

  doMouseDown(o) {
    const canvas = this._canvas
    this.isDown = true
    const pointer = canvas.getPointer(o.e)
    this.startX = pointer.x
    this.startY = pointer.y

    if (
      canvas.backgroundImage &&
      canvas.backgroundImage.lineCoords.tl.x <= o.pointer.x &&
      canvas.backgroundImage.lineCoords.tr.x >= o.pointer.x &&
      canvas.backgroundImage.lineCoords.tl.y <= o.pointer.y &&
      canvas.backgroundImage.lineCoords.bl.y >= o.pointer.y
    ) {
      this.rect = new fabric.Rect({
        left: this.startX,
        top: this.startY,
        originX: 'left',
        originY: 'top',
        width: pointer.x - this.startX,
        height: pointer.y - this.startY,
        stroke: '#fcd303',
        strokeDashArray: [5, 5],
        strokeWidth: 3,
        fill: this._fill,
        transparentCorners: false,
        selectable: false,
        evented: false,
        strokeUniform: true,
        noScaleCache: false,
        angle: 0
      })
      canvas.add(this.rect)
    } else {
      this.isDown = false
    }
  }

  doMouseMove(o) {
    if (!this.isDown) return
    if (this.rect) {
      const canvas = this._canvas
      const pointer = canvas.getPointer(o.e)
      if (this.startX > pointer.x) {
        this.rect.set({ left: Math.abs(pointer.x) })
      }
      if (this.startY > pointer.y) {
        this.rect.set({ top: Math.abs(pointer.y) })
      }
      this.rect.set({ width: Math.abs(this.startX - pointer.x) })
      this.rect.set({ height: Math.abs(this.startY - pointer.y) })
      this.rect.setCoords()
      canvas.renderAll()
    }
  }

  doMouseUp(o) {
    if (this.rect) {
      this._canvas.remove(this.rect)
    }
    this.isDown = false
  }
}

export default Crop
